module.exports = __webpack_public_path__ + "static/media/google.90663754.png";